<div class="user-icon">
  {{letter}}
</div>
